<template>    
    <div class="modal fade" id="notifications-popup" tabindex="-1" role="dialog" aria-labelledby="notificationsPopup" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-body center" v-if="status !== 'ready'">
                    <p class="loading" v-if="status === 'loading'"><i class="fas fa-circle-notch fa-spin"></i></p>
                    <button class="retry" v-if="status === 'error'" @click="init()"><i class="fas fa-exclamation-triangle"></i>Retry</button>
                </div>
                <template v-if="notification">
                    <div class="modal-header">
                        <h2 class="modal-title">
                            <span class="text"><i class="fas fa-comment"></i>{{ __('Title', notification) }}</span>
                            <button class="close-modal" @click="closePopup()"><i class="fas fa-times"></i></button>
                        </h2>
                        <div class="tags">
                            <p class="tag date"><i class="fas fa-clock"></i>{{ notification.CreatedAt | humanize }}</p>
                            <p :class="[ 'tag', 'Severity', notification.Severity.Name.toLowerCase() ]" v-if="hasSeverity">
                                <i :class="notification.Severity.Icon" v-if="hasSeverityIcon"></i>
                                {{ notification.Severity.Name }}
                            </p>
                            <a class="tag url" :href="notification.Url" target="_blank" v-if="hasUrl"><i class="fas fa-link"></i>Visit URL</a>
                        </div>
                    </div>
                    <div class="modal-body">
                        <p class="description" v-html="notification.Description"></p>
                    </div>
                    <div class="modal-footer">
                        <button class="footer-btn" @click="closePopup()">Close</button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationsService from "@/services/NotificationsService";

export default {
    name: "notifications-popup",
    components: {
        // 
    },
    data() {
        return {
            status: "loading",
            notification: null
        };
    },
    methods: {
        async init() {
            this.status = "loading";
            this.clearNotification();
            try {
                let response = await NotificationsService.getSingleUserNotification(this.notificationId);
                this.notification = response.data[0];
                this.status = "ready";
            } catch(e) {
                this.status = "error";
                this.clearNotification();
            }
        },
        closePopup() {
            this.$store.commit("notifications/closeNotificationsPopup");
        },
        clearNotification() {
            this.notification = {
                Id: null,
                Title: "",
                Description: "",
                Url: "",
                SeverityId: null,
                Severity: null,
                CreatedAt: null,
                HasBeenDismissed: false,
                HasBeenRead: false
            };
        }
    },
    computed: {
        notificationId() {
            return this.$store.getters["notifications/notificationsPopupId"];
        },
        hasUrl() {
            return !!(this.notification && this.notification.url && this.notification.url.length);
        },
        hasSeverity() {
            return !!(this.notification.severity && this.notification.severity.name && this.notification.severity.name.length);
        },
        hasSeverityIcon() {
            return !!(this.notification.severity.icon && this.notification.severity.icon.length);
        },
    },
    watch: {
        notificationId(value) {
            if(value !== null && value !== undefined)
                this.init();
            else
                this.closePopup();
        }
    }
}
</script>
